import { Controller } from '@hotwired/stimulus';
import Axios from 'axios';
import { dashboardAction } from '../../../../../resources/js/helpers';

export default class extends Controller {
    static targets = ['list', 'notification', 'status'];

    connect() {
        if (this.element.dataset.refreshInterval) {
            this.interval = setInterval(() => this.refresh(), 1000 * parseInt(this.element.dataset.refreshInterval));
        }
    }

    notificationTargetConnected(element) {
        if (this.hasStatusTarget && !parseInt(element.dataset.isRead)) {
            this.statusTarget.classList.remove('d-none');
        }
    }

    async navigate(event) {
        event.preventDefault();

        const isRead = event.currentTarget.dataset.isRead;
        const id = event.currentTarget.dataset.notificationId;
        const href = event.currentTarget.href;

        if (!parseInt(isRead) && id) {
            try {
                await Axios['post'](dashboardAction('notifications', 'notification', 'read', [id]));
            } catch (error) {
                console.error(error);
            }
        }

        if (href) {
            Turbo.visit(href);
        }
    }

    async refresh() {
        if (!this.hasListTarget) {
            clearInterval(this.interval);
            return;
        }

        if (this.element.classList.contains('notifications-refresh-loading')) {
            return;
        }

        this.element.classList.add('notifications-refresh-loading');
        await this.listTarget.reload();
        this.element.classList.remove('notifications-refresh-loading');
    }
}
